import { z } from "zod";

import { BILLING_INTERVALS } from "../constants";

/**
 * What the client may say about a checkout: an interval, and nothing else. No price id, no
 * amount, no currency, no customer id — a client that could name a price could name a
 * one-cent one — and no return path either, since where Stripe sends the browser back is a
 * product decision the server owns (see the server's http/urls.ts).
 */
export const createCheckoutSchema = z.object({
  interval: z.enum(BILLING_INTERVALS),
});

export type CreateCheckoutInput = z.infer<typeof createCheckoutSchema>;
